module.exports = __webpack_public_path__ + "img/home-company.39287c84.png";